import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from './api';

const styles = {
    container: {
        width: '420px',
        margin: '40px auto',
        fontFamily: 'sans-serif',
        border: '1px solid #ccc',
        padding: '20px 40px',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
    formGroup: { marginBottom: '15px' },
    label: { display: 'block', marginBottom: '5px', fontWeight: 'bold' },
    input: { width: '100%', padding: '10px', boxSizing: 'border-box' },
    button: {
        width: '100%',
        padding: '10px 15px',
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '16px',
    },
    error: { color: '#dc3545', marginTop: '10px', textAlign: 'center' },
    success: {
        color: '#155724',
        marginTop: '10px',
        textAlign: 'center',
        backgroundColor: '#d4edda',
        border: '1px solid #c3e6cb',
        borderRadius: '4px',
        padding: '12px',
    },
    link: { display: 'block', marginTop: '16px', textAlign: 'center', color: '#007bff' },
    subtitle: { color: '#666', marginBottom: '20px', lineHeight: 1.5 },
};

function formatError(err) {
    const data = err?.response?.data;
    if (!data) return 'Unable to reset your password. Please try again.';
    if (typeof data === 'string') return data;
    if (data.error) return data.error;
    if (data.detail) return data.detail;
    return Object.entries(data)
        .map(([field, messages]) => {
            const label = field.replace(/_/g, ' ');
            const text = Array.isArray(messages) ? messages.join(' ') : String(messages);
            return `${label}: ${text}`;
        })
        .join(' ');
}

function ResetPasswordPage() {
    const { uid, token } = useParams();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (newPassword !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        setSubmitting(true);
        try {
            await api.post('/password-reset-confirm/', {
                uid,
                token,
                new_password: newPassword,
            });
            setSubmitted(true);
        } catch (err) {
            setError(formatError(err));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div style={styles.container}>
            <h2>Reset Password</h2>
            <p style={styles.subtitle}>
                Choose a new password for your ATLAS account.
            </p>

            {submitted ? (
                <div style={styles.success}>
                    Your password has been reset. You can now log in with your new password.
                </div>
            ) : (
                <form onSubmit={handleSubmit}>
                    <div style={styles.formGroup}>
                        <label style={styles.label} htmlFor="newPassword">New Password</label>
                        <input
                            id="newPassword"
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            style={styles.input}
                            required
                        />
                    </div>
                    <div style={styles.formGroup}>
                        <label style={styles.label} htmlFor="confirmPassword">Confirm Password</label>
                        <input
                            id="confirmPassword"
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            style={styles.input}
                            required
                        />
                    </div>
                    {error && <p style={styles.error}>{error}</p>}
                    <button type="submit" style={styles.button} disabled={submitting}>
                        {submitting ? 'Resetting...' : 'Reset Password'}
                    </button>
                </form>
            )}

            <Link to="/login" style={styles.link}>Back to Login</Link>
        </div>
    );
}

export default ResetPasswordPage;
